import { useState } from "react";
import AccountPopover from "./AccountPopover";
import { RootState } from "store/store";
import { connect } from "react-redux";
import UserResponse from "interfaces/response/UserResponse";
import AccountAvatar from "./AccountAvatar";

interface Props {
  user?: UserResponse;
}

export function Account(props: Props) {
  const [isAccountPopoverVisible, setIsAccountPopoverVisible] = useState(false);

  const { user } = props;

  const handleAccountPopoverHiding = () => {
    setIsAccountPopoverVisible(false);
  };

  const handleAccountMenuClick = () => {
    setIsAccountPopoverVisible(!isAccountPopoverVisible);
  };

  return (
    <>
      <div className="flex justify-center w-full md:w-auto select-none">
        <div>
          <div
            id="account-menu"
            className={`cursor-pointer pl-4 flex justify-center items-center ${
              isAccountPopoverVisible
                ? "bg-primaryRed bg-opacity-11 rounded-full"
                : ""
            }`}
            onClick={handleAccountMenuClick}
          >
            <div className="text-base font-medium mr-2">Account</div>
            <AccountAvatar
              user={user}
              displayCrossIcon={isAccountPopoverVisible}
            />
          </div>
        </div>
        <AccountPopover
          user={user}
          visible={isAccountPopoverVisible}
          onHiding={handleAccountPopoverHiding}
          target="#account-menu"
        />
      </div>
    </>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  return {
    user: state.userData.currentUserDetail,
  };
};

export default connect(mapStateToProps, null)(Account);
